module.exports = __webpack_public_path__ + "static/img/no_pms.2d7e3b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/components/no_pms.png
// module id = rgFP
// module chunks = 1